import React from 'react';
import { FiLinkedin, FiInstagram } from 'react-icons/fi';

const PLATFORM_MAP = {
  linkedin: {
    icon: FiLinkedin,
    label: 'LinkedIn',
    color: 'text-[#0A66C2]',
    bg: 'bg-[#0A66C2]/10',
    ring: 'ring-[#0A66C2]/20',
  },
  instagram: {
    icon: FiInstagram,
    label: 'Instagram',
    color: 'text-[#E1306C]',
    bg: 'bg-gradient-to-br from-[#F58529]/10 via-[#DD2A7B]/10 to-[#8134AF]/10',
    ring: 'ring-[#DD2A7B]/20',
  },
};

export default function PlatformBadge({ platform = 'linkedin', size = 'sm', showLabel = true, className = '' }) {
  const config = PLATFORM_MAP[platform] || PLATFORM_MAP.linkedin;
  const Icon = config.icon;

  const sizes = {
    xs: { badge: 'px-1.5 py-0.5 text-[10px]', icon: 'w-3 h-3' },
    sm: { badge: 'px-2 py-1 text-xs', icon: 'w-3.5 h-3.5' },
    md: { badge: 'px-2.5 py-1 text-sm', icon: 'w-4 h-4' },
  };

  const s = sizes[size] || sizes.sm;

  return (
    <span className={`inline-flex items-center gap-1 rounded-lg font-medium ring-1 ${config.bg} ${config.color} ${config.ring} ${s.badge} ${className}`}>
      <Icon className={s.icon} />
      {showLabel && <span>{config.label}</span>}
    </span>
  );
}
